var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktokLogoV2 = function SvgTiktokLogoV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    d: "M21.211 6.393c-1.3-.04-2.48-.663-3.369-1.496a4.87 4.87 0 0 1-1.51-3.595H12.71v13.953c0 2.279-1.366 3.622-3.044 3.622a3.046 3.046 0 1 1 .984-5.917V9.276a4.5 4.5 0 0 0-.984-.104 6.665 6.665 0 1 0 6.662 6.664v-7.51c1.404.971 3.081 1.43 4.871 1.462z"
  })));
};
export default SvgTiktokLogoV2;